export default {
  introduce: {
    left: {
      costs: '素材費用の透明化',
      service: 'サービス料金は実際の使用量に基づいて請求されます',
      advertisement: '広告効果に直接投資、料金は{rate}まで低減可能',
      limit: '限定',
      gift: '50個の大特典パッケージもあります',
      contact: '。お早めにご連絡ください！',
      email: '連絡先メールアドレス：creative@mindworks-creative.com',
      apply: '直接的に出稿する',
    },
    right: {
      costs: '制作費用',
      consume: '広告消費費用 $100',
      material: '素材制作費用 $3',
      low: '最低3%',
    },
    banner: {
      title:
        'トップアップを完了した最初の50人の顧客には、特大ギフトパッケージがプレゼントされます！',
    },
  },
  suggest: {
    select: {
      title: '二重選択制、カスタマイズが柔軟',
      describe: 'セルフサービスと代理制作の料金モデル',
    },
    lead: {
      title: 'ビジュアル革命の先導',
      describe: '豊富なプレイアブル素材庫',
    },
    data: {
      title: 'データインサイトによる成果推進',
      describe: '素材最適化によるコンバージョン向上',
    },
  },
  detail: {
    title: 'イベントの詳細',
    main: {
      question1: 'この課金モデルはすべてのチャンネルに適していますか？',
      content1:
        '当社のプレイアブル消費に基づく価格モデルは、現在Mintegral、ApplovinとUnity三つのネットワークをサポートしています。',
      question2:
        '広告費に基づいて、プレイアブルのコストはどのように計算されるのですか？',
      content2: {
        title:
          '各素材に対して、費用はその素材の広告費用の固定割合に基づいて計算されます。具体的な数値は、広告主が選択した制作方法によって異なります。',
        article1: 'Playturboセルフサービスプラットフォーム',
        describe1:
          '広告主がPlayturboを利用して素材を制作する場合、費用の割合は 3％ となります。つまり、素材広告費の 3％ を素材制作費として支払うだけで済みます。',
        article2: 'Mindworksクリエイティブ最適化サービス',
        describe2:
          'Playturboのプロフェッショナルチームによる素材制作をご選択の場合、コストパーセンテージは 6％ となります。この場合、素材広告費の 6％ を素材制作費としてお支払いいただきます。',
        tips: 'こうしたさまざまなオプションを提供することで、広告主のニーズに応え、広告費に見合ったコストを確保することを目指しています。弊社の目標は、素材の製作コストを削減し、広告予算を最大限に活用して投資利益を向上させることです。',
      },
      question3:
        '最低預入金額はいくらですか？請求額はどのように計算されますか？',
      content3: {
        title:
          'サービスをご利用いただくには、最低 800 ドルのデポジットが必要です。これは、広告キャンペーンの継続性と安定性を保証するための前払い金となります。',
        example: '例：',
        assume:
          '以下は、Mintegralでセルフサービス制作モードを利用した場合の課金計算の例です:\n複数のプレイアブル素材を同時に配信し、異なる月に開始したとします。毎月の課金の内訳は以下の通りです：',
        article1: '10月 ：素材A、B、C、Dを作成し、配信：',
        october: {
          materialA: '素材A：広告費 100 ドル',
          materialB: '素材B：広告費 1000 ドル',
          materialC: '素材C：広告費 300 ドル',
          materialD: '素材D：広告費 0 ドル（未配信）',
          cost: '10月の請求',
          costA: '素材Aの費用：100ドル × 3％＝ 3 ドル',
          costB: '素材Bの費用：1000ドル × 3％＝ 30 ドル',
          costC: '素材Cの費用：300ドル × 3％＝ 9 ドル',
          costD: '素材Dの費用：0ドル（未配信）',
          totalCost: '10月の合計：$3 + $30 + $9 = $42',
        },
        article2:
          '11月： 素材AとBは継続、素材Cは配信中止、素材DとEを作成し配信：',
        november: {
          materialA: '素材A：広告費100ドル',
          materialB: '素材B：広告費200ドル',
          materialC: '素材C：広告費0ドル（中止）',
          materialD: '素材D：広告費300ドル',
          materialE: '素材E：広告費400ドル',
          cost: '11月の請求：',
          costA: '素材Aの費用：100 ドル × 3％ ＝ 3 ドル',
          costB: '素材Bの費用：200 ドル ×  3％ ＝ 6ドル',
          costC: '素材Cの費用：0 ドル（中止）',
          costD: '素材Dの費用：300 ドル  x  3% = 9ドル',
          costE: '素材Eの費用：400 ドル  x  3% = 12ドル',
          totalCost: '11月の合計：$3 + $6 + $9 + $12 = $30',
        },
        tips: '*毎月の課金計算では、各素材の広告費を考慮し、それに応じて費用を合計していることにご留意ください。',
      },
      interpret: '*キャンペーンの解釈権は Mindworks、Mintegral に帰属します',
    },
  },
  form: {
    only: '数量限定',
    gif: '50個のギフトパッケージ',
    click: '、ボタンをクリックしてギフトをゲット！',
    promptly: '早くお問い合わせください！',
    advertisement: '広告効果に直接投資、',
    rate: '料金は{rate}まで低減可能',
    contact: 'お問い合わせ',
  },
}
